import { InjectionToken } from '@angular/core';
import { AppColors } from '../../config/colors';

export const COLOR_TOKENS = new InjectionToken<AppColors>('COLOR_TOKENS');
